import React, { useMemo, useContext, useCallback, useState } from 'react'
import { Flex, Box } from 'reflexbox'
import { Formik, Form } from 'formik'
import { ThemeContext } from 'styled-components'
import { toast } from 'react-toastify'
import { useHistory, Link } from 'react-router-dom'

import Card from 'components/Card'
import Breadcrumb from 'components/Breadcrumb'
import Button from 'components/Button'
import Loader from 'components/Loader'
import { TextField } from 'components/Form'
import { Title, SemiTitle, Text } from 'components/Typography'

import { phoneMask } from 'helpers/masks'
import { useUser } from 'context/user-context'
import { useAuth } from 'context/auth-context'
import { editUserInfo } from 'services/partners'

const breadcrumbPath = [
  {
    label: 'Configurações',
    link: '/settings',
  },
  {
    label: 'Editar informações',
  },
]

const Edit = () => {
  const theme = useContext(ThemeContext)
  const history = useHistory()
  const {
    user: { id: userID, ...user },
    setUser,
  } = useUser()
  const { reload } = useAuth()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const initialValues = {
    responsible_name: user.responsible_name,
    phone: user.phones[0].number,
    email: user.user.email,
  }

  const dateOptions = useMemo(() => Array.from(Array(28).keys()).map(day => ({ label: day + 1, value: day + 1 })), [])

  const handleSubmit = useCallback(async values => {
    try {
      setIsSubmitting(true)

      const formattedData = Object.entries(values).reduce((acc, [key, value]) => {
        if (value !== initialValues[key]) {
          switch (key) {
            case 'phone': {
              return { ...acc, phones: [{ number: value }] }
            }
            case 'email': {
              return { ...acc, user: { [key]: value } }
            }
            default: {
              return { ...acc, [key]: value }
            }
          }
        }
        return acc
      }, {})

      const { data } = await editUserInfo(userID, formattedData)
      const result = { ...data }

      setUser(result)
      reload()
      toast.success('Informações atualizadas com sucesso!')
      setIsSubmitting(false)

      history.push('/settings')
    } catch (e) {
      console.log(e)
      setIsSubmitting(false)
      toast.error('Não foi possivel atualizar as suas informações no momento.')
    }
  }, [])

  return (
    <>
      <Flex flexDirection='column' width={1}>
        <Breadcrumb children={breadcrumbPath} />
        <Title as='h3'>Editar informações</Title>
        <Card mt={24}>
          <Flex flexDirection='column' width={1}>
            <Flex flexDirection='row' flexWrap='wrap'>
              <Flex flexDirection='column' width={['100%', '50%', '50%']}>
                <Formik
                  initialValues={initialValues}
                  onSubmit={async values => {
                    handleSubmit(values)
                  }}
                >
                  <Form>
                    <Box mb={32}>
                      <SemiTitle color={theme.colors.grays.N500}>CNPJ</SemiTitle>
                      <Text>{user.document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')}</Text>
                    </Box>

                    <Box mb={32}>
                      <SemiTitle color={theme.colors.grays.N500}>Razão Social</SemiTitle>
                      <Text>{user.company_name}</Text>
                    </Box>

                    <TextField
                      name='responsible_name'
                      label='Nome do responsável'
                      placeholder='Nome do responsável'
                      mb={32}
                    />
                    <TextField
                      name='phone'
                      label='Telefone'
                      placeholder='Telefone'
                      mask={phoneMask}
                      guide={false}
                      mb={32}
                    />
                    <TextField name='email' label='E-mail' placeholder='E-mail' mb={32} />

                    <Flex width={584} justifyContent='space-between'>
                      <Button as={Link} to='/settings' size='big' outlined>
                        Voltar
                      </Button>
                      <Button size='big' disabled={isSubmitting}>
                        {isSubmitting ? <Loader /> : 'Salvar'}
                      </Button>
                    </Flex>
                  </Form>
                </Formik>
              </Flex>
            </Flex>
          </Flex>
        </Card>
      </Flex>
    </>
  )
}

export default Edit
